import { Sparkles } from 'lucide-react';

const SAMPLE_PROMPTS = [
  'What is the total revenue for Infosys over the last 5 years?',
  'Compare EBIT between Infosys and TCS.',
  'Show me the profit-and-loss for any Indian IT company in FY 2023.',
  'Which companies have filed annual reports in the last year?',
];

interface Props {
  onPromptClick: (prompt: string) => void;
  disabled?: boolean;
}

export default function EmptyState({ onPromptClick, disabled }: Props) {
  return (
    <div className="max-w-2xl mx-auto py-10 text-center">
      <div className="w-14 h-14 mx-auto mb-5 rounded-2xl bg-gradient-to-br from-primary-100 to-secondary-100 flex items-center justify-center">
        <Sparkles className="w-7 h-7 text-primary-600" />
      </div>
      <h2 className="text-xl font-bold text-neutral-900 mb-2 text-balance">
        I answer questions about your knowledge graph.
      </h2>
      <p className="text-sm text-neutral-600 max-w-md mx-auto mb-6">
        Every claim I make is cited with the nodes and relationships I used —
        no open-web answers.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2.5">
        {SAMPLE_PROMPTS.map((p) => (
          <button
            key={p}
            type="button"
            disabled={disabled}
            onClick={() => onPromptClick(p)}
            className="text-left p-3.5 bg-white border border-neutral-200 rounded-xl hover:border-primary-300 hover:bg-primary-50 hover:shadow-sm transition-all text-sm text-neutral-700 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {p}
          </button>
        ))}
      </div>
    </div>
  );
}
